import React, { Component } from 'react'
import PropTypes from 'prop-types'

class HudlVideoPlayer extends Component {
  static propTypes = {
    videoId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }

  state = {
    iframeKey: 0,
  }

  pauseVideoPlayback = () => {
    this.setState({
      // Updating the iframeKey causes the iframe to reload its
      // content (because the key is what React uses to keep a
      // "connection" with the component.)
      iframeKey: this.state.iframeKey + 1
    })
  }

  render() {
    const { iframeKey } = this.state
    const { title, videoId } = this.props

    return (
      <div className="hudle-video-player" >
        <iframe
          title={title}
          key={iframeKey}
          src={`https://www.hudl.com/embed/video/${videoId}`}
          width='640'
          height='360'
          frameBorder='0'
          allowFullScreen
        />
      </div>
    )
  }
}

export default HudlVideoPlayer


// WEBPACK FOOTER //
// ./src/components/Global/HudlVideoPlayer.js